import React, { useMemo, useState } from "react";
import { Card, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faPlus } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import { UI_COLORS } from "../../config";
import KeysList from "../KeysList/KeysList";
import AddKeyModal from "../AddKeyModal";
import { useAppManager } from "../../hooks/useAppManager";
import { useTranslation } from "../../i18n";
export function KeysCard({ handleRefreshKeys }) {
  const { t } = useTranslation();
  const {
    userActions,
    selectedTenant,
    keys,
    selectedKey,
    isLoadingKeys,
    keysError,
    selectKey,
    getKeyById,
    createKey,
  } = useAppManager();
    const canRead = useMemo(
    () => userActions?.includes('dpp-qr-read'),
    [userActions]
  );
  const refreshIcon = useMemo(
    () => <FontAwesomeIcon icon={faArrowsRotate} />,
    []
  );
  const newIcon = useMemo(() => <FontAwesomeIcon icon={faPlus} />, []);
  const keysListProps = useMemo(
    () => ({
      allKeys: keys,
      isLoading: isLoadingKeys,
      error: keysError,
      onKeySelect: selectKey,
      selectedKey,
      onClearSearch: handleRefreshKeys,
      getKeyById,
    }),
    [keys, isLoadingKeys, keysError, selectKey, selectedKey, handleRefreshKeys, getKeyById]
  );

  const tenantName = selectedTenant?.name || "—";
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  return (
    <div className="w-full md:w-2/5 lg:w-1/3 h-1/2 md:h-full">
      <Card
        size="small"
        styles={{
          body: {
            height: "calc(100% - 50px)",
          },
        }}
        className="h-full"
        title={
          <h3
            className="text-lg font-medium truncate"
            style={{ color: UI_COLORS.primary }}
          >
            {`${tenantName} Keys`.toUpperCase()}
          </h3>
        }
        extra={
          <div className="flex items-center gap-2 p-2">
            {!keysError && canRead && (
              <Button
                style={{
                  backgroundColor: UI_COLORS.primary,
                  color: UI_COLORS.white,
                  padding: "4px 8px 4px 4px",
                  borderRadius: "4px",
                  border: "none",
                  cursor: "pointer",
                  transition: "all 0.3s",
                }}
                onClick={() => setIsAddModalOpen(true)}
                icon={newIcon}
                disabled={!createKey}
              >
                {t("keysList.newQrCode")}
              </Button>
            )}

            <Button
              color="primary"
              variant="text"
              onClick={handleRefreshKeys}
              icon={refreshIcon}
              disabled={isLoadingKeys}
              style={{ color: UI_COLORS.primary }}
            >
              {t("keysList.refresh")}
            </Button>
          </div>
        }
      >
        <div className="p-4 h-full flex flex-col">
          <KeysList {...keysListProps} />
        </div>
      </Card>

      <AddKeyModal
        visible={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        createKey={createKey}
        onCreated={() => {
          setIsAddModalOpen(false);
          handleRefreshKeys();
        }}
      />
    </div>
  );
}

KeysCard.propTypes = {
  selectedTenant: PropTypes.object,
  isLoadingKeys: PropTypes.bool,
  handleRefreshKeys: PropTypes.func.isRequired,
  keys: PropTypes.array,
  keysError: PropTypes.any,
  selectKey: PropTypes.func.isRequired,
  selectedKey: PropTypes.object,
  createKey: PropTypes.func,
  getKeyById: PropTypes.func,
};

KeysCard.defaultProps = {
  keys: [],
  isLoadingKeys: false,
};

export default React.memo(KeysCard);
